import { Link } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";

// actionsOneLine: keep all action buttons on a single line (they move under the title as one row if needed).
export default function PageHeader({ title, subtitle, actions, backTo, backLabel = "Back", actionsOneLine = false }) {
  return (
    <div className="page-header">
      <div className="page-header-text">
        {backTo && (
          <Link to={backTo} className="page-back">
            <FiChevronLeft size={16} aria-hidden="true" />
            {backLabel}
          </Link>
        )}
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className={`page-header-actions${actionsOneLine ? " is-one-line" : ""}`}>{actions}</div>}
    </div>
  );
}
